import { render, staticRenderFns } from "./batch-save-dialog.vue?vue&type=template&id=028f6aa6&scoped=true&"
import script from "./batch-save-dialog.vue?vue&type=script&lang=js&"
export * from "./batch-save-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028f6aa6",
  null
  
)

export default component.exports